import { render } from "./PersonalizedPopupTemplate2.vue?vue&type=template&id=67e993c9"
import script from "./PersonalizedPopupTemplate2.vue?vue&type=script&lang=js"
export * from "./PersonalizedPopupTemplate2.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__